/* recently-viewed.js - localStorage-backed strip of recently viewed products */
(function () {
  'use strict';

  const STORAGE_KEY = 'bf_recently_viewed';
  const MAX_HISTORY = 16; // store more than we render so excludes don't shrink the strip

  function readHistory() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (_) {
      return [];
    }
  }
  function writeHistory(arr) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(arr)); }
    catch (_) { /* localStorage may be unavailable */ }
  }

  function recordCurrent(handle) {
    if (!handle) return;
    const history = readHistory().filter(h => h !== handle);
    history.unshift(handle);
    writeHistory(history.slice(0, MAX_HISTORY));
  }

  function fetchCard(handle) {
    return fetch(`/products/${handle}?view=card`, { credentials: 'same-origin' })
      .then(r => r.ok ? r.text() : Promise.reject(r.status))
      .then(html => html.trim())
      .catch(() => null);
  }

  async function render(section) {
    const grid = section.querySelector('[data-recently-viewed-grid]');
    if (!grid) return;
    const currentHandle = section.dataset.currentHandle || '';
    const limit = parseInt(section.dataset.limit, 10) || 8;
    const handles = readHistory().filter(h => h && h !== currentHandle).slice(0, limit);
    if (!handles.length) return;

    const results = await Promise.all(handles.map(fetchCard));
    const fragments = results.filter(Boolean);
    if (!fragments.length) return;

    grid.innerHTML = fragments.join('');
    section.hidden = false;

    // Mount any image-loader wrappers in the freshly inserted cards.
    if (window.BoniImageLoader && typeof window.BoniImageLoader.mountAll === 'function') {
      window.BoniImageLoader.mountAll(grid);
    }
  }

  function init() {
    const section = document.querySelector('[data-recently-viewed]');
    const currentHandle = section ? section.dataset.currentHandle : '';

    // On a PDP: record current product BEFORE rendering (so it's excluded from strip)
    if (currentHandle) recordCurrent(currentHandle);

    if (section) render(section);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
